import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {OzowPaymentUpdateRequest} from "../../interfaces/ozow/ozow";

@Injectable()

export class OzowEftApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/ozow' : environment.baseUrl + '/ozow';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public initializePayment(sessionToken: string): Observable<any> {
      const url = this.baseUrl + `/initialize?sessionToken=${sessionToken}`;
      return super.post(url, "");
    }

  public update(sessionToken: string, ozowPaymentUpdateRequest: OzowPaymentUpdateRequest): Observable<any> {
    const url = this.baseUrl + `/status?sessionToken=${sessionToken}`;
    return super.post(url, ozowPaymentUpdateRequest);
  }

}
